import { createSlice } from "@reduxjs/toolkit";

const initialState = { data: [], isLoading: true };

const billboardSlice = createSlice({
  name: "billboard",
  initialState,
  reducers: {
    setBillboardMessages: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setBillboardMessages } = billboardSlice.actions;

export default billboardSlice.reducer;
